import React from "react";
import PageHeader from "../../PageHeader";
import { ReactComponent as AddIcon } from "../../../images/pageheadingicon/addicon.svg";
import { ReactComponent as SectionIcon } from "../../../images/sectionimage/Section.svg";
import useStyles from "../../../../styles";
import ViewSection from "./ViewSection";


function Section() {
  const classes = useStyles();
  const Heading = [
    {
      id: 1,
      pageicon:<SectionIcon />,
      mainheading: "Section",
      // subhead: "Want to Add in Bulk ? ?",
      // downloadlink: "Download bulk Sample Files",
      addbtntext:"Create New section",
      addbtnicon: <AddIcon />,
      addbtnstyle: "bluebtn",
      path:"/admin/addsection",
    },
  ];
  return (
    <div className={`${classes.p1} ${classes.pb0}`}>
      <PageHeader Heading={Heading}/>
      <ViewSection/>
    </div>
  );
}
export default Section;